/* =========================================================
   Hydrizm LP – CTA プランスライダー
   商品画像は固定、価格ボックス以下だけを横スワイプで切り替える。
   ネイティブのスクロールスナップで動くため、JSが止まっても
   指でのスワイプは機能する（ドットの同期だけが失われる）。
   ========================================================= */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.hzSliderReady === '1') return;
    root.dataset.hzSliderReady = '1';

    var track = root.querySelector('[data-hz-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hz-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hz-dot]'));
    if (!track || slides.length < 2) return;

    var current = 0;

    function paint(i) {
      if (i === current) return;
      current = i;
      dots.forEach(function (d, n) {
        d.classList.toggle('is-on', n === i);
        d.setAttribute('aria-selected', n === i ? 'true' : 'false');
        d.tabIndex = n === i ? 0 : -1;
      });
      slides.forEach(function (s, n) {
        /* 表示外のスライドはタブ順から外す */
        s.querySelectorAll('a, button, input, select').forEach(function (el) {
          if (n === i) { el.removeAttribute('tabindex'); }
          else { el.setAttribute('tabindex', '-1'); }
        });
      });
    }

    function nearest() {
      var x = track.scrollLeft + track.clientWidth / 2;
      var best = 0, bestD = Infinity;
      slides.forEach(function (s, n) {
        var c = s.offsetLeft + s.offsetWidth / 2;
        var d = Math.abs(c - x);
        if (d < bestD) { bestD = d; best = n; }
      });
      return best;
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        paint(nearest());
      });
    }, { passive: true });

    function goTo(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      var s = slides[i];
      track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2, behavior: 'smooth' });
      paint(i);
    }

    dots.forEach(function (d, n) {
      d.addEventListener('click', function () { goTo(n); });
      d.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1); dots[Math.min(dots.length - 1, current)].focus(); }
        if (e.key === 'ArrowLeft')  { e.preventDefault(); goTo(current - 1); dots[Math.max(0, current)].focus(); }
      });
    });

    /* 初期状態を反映（current=0 のまま paint が走らないため明示） */
    current = -1;
    paint(0);
  }

  function initAll() {
    document.querySelectorAll('[data-hz-slider]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
